'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var convert = require('./index.js');

var textarea = document.querySelector('textarea.code');
var target = document.querySelector('pre.code');
var demos = [].concat(_toConsumableArray(document.querySelectorAll('button')));

function eventHandler() {
	if (this.tagName == 'BUTTON') textarea.value = this.value;
	target.innerHTML = convert(this.value);
}
if (demos && textarea) {
	textarea.addEventListener('input', eventHandler);
	demos.forEach(function (el) {
		return el.addEventListener('click', eventHandler);
	});
}

module.exports = convert;


//////////////////
// WEBPACK FOOTER
// ./src/demo.js
// module id = 6
// module chunks = 0